import { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useTransform } from 'framer-motion';
import { LANDING } from '@/constants/testIds';

export default function Nav() {
  const { scrollY } = useScroll();
  const bg = useTransform(scrollY, [0, 80], ['rgba(250,248,244,0)', 'rgba(250,248,244,0.92)']);
  const border = useTransform(scrollY, [0, 80], ['rgba(17,17,17,0)', 'rgba(17,17,17,0.08)']);

  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, []);

  return (
    <motion.header
      style={{ backgroundColor: bg, borderBottomColor: border }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <a
          href="#hero"
          data-testid={LANDING.navLogo}
          className="font-display text-xl tracking-[0.18em] text-[#111] select-none"
        >
          KIVO
        </a>

        <nav className="hidden md:flex items-center gap-10 text-[13px] tracking-wide text-[#111]/70">
          <a href="#collections" data-testid={LANDING.navExplore} className="hover:text-[#111] transition-colors">
            Collection
          </a>
          <a href="#ritual" className="hover:text-[#111] transition-colors">Ritual</a>
          <a href="#challenge" className="hover:text-[#111] transition-colors">Challenge</a>
          <a href="#story" className="hover:text-[#111] transition-colors">Story</a>
        </nav>

        <a
          href="#waitlist"
          data-testid={LANDING.navWaitlist}
          className="hidden sm:inline-flex items-center gap-2 text-[12px] tracking-[0.2em] uppercase text-[#FAF8F4] bg-[#111] px-5 py-2.5 rounded-full hover:bg-[#000] transition-all hover:-translate-y-0.5"
        >
          Early Access
          <span className="text-[#CBBBA0]">→</span>
        </a>

        <button
          type="button"
          aria-label="Open menu"
          className="md:hidden text-[#111] text-2xl"
          onClick={() => setOpen((v) => !v)}
        >
          ≡
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            className="md:hidden px-6 pb-6 pt-2 bg-[#FAF8F4] border-t border-black/5"
          >
            {[
              ['Collection', '#collections'],
              ['Ritual', '#ritual'],
              ['Challenge', '#challenge'],
              ['Story', '#story'],
              ['Early Access', '#waitlist'],
            ].map(([label, href]) => (
              <a
                key={href}
                href={href}
                onClick={() => setOpen(false)}
                className="block py-3 text-[15px] tracking-wide text-[#111] border-b border-black/5 last:border-b-0"
              >
                {label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
